import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "equalizer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createBlock(_component_NcButton, {
    disabled: $props.disabled,
    class: "media-devices-speaker-test-button",
    title: $options.buttonLabel,
    "aria-label": $options.buttonLabel,
    variant: "secondary",
    onClick: $options.playTestSound
  }, {
    icon: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.equalizerBars, (bar) => {
          return (_openBlock(), _createElementBlock("div", {
            key: bar.key,
            class: _normalizeClass(["equalizer__bar", { 'equalizer__bar--active': $options.isPlayingTestSound }]),
            style: _normalizeStyle(bar.style)
          }, null, 6))
        }), 128))
      ])
    ]),
    default: _withCtx(() => [
      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Test')), 1)
    ]),
    _: 1
  }, 8, ["disabled", "title", "aria-label", "onClick"]))
}